<template>
  <form name="customer" class="needs-validation" novalidate>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="alert.message = ''"
      ></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
      ><br />
      {{ alert.reason }}
    </div>

    <div class="row mb-4">
      <div class="col-md-2" v-if="data.id">
        <label for="id">ID</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder=""
            v-model="data.id"
            readonly="readonly"
            id="id"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div
          class="form-group"
          :class="{
            'has-danger':
              !data.document ||
              (data.document && !validateDocument(data.document)),
          }"
        >
          <label for="document"
            >Documento <span class="m--font-danger">*</span></label
          >
          <div class="input-group">
            <input
              type="text"
              class="form-control m-input"
              id="document"
              placeholder=""
              v-model="data.document"
              v-mask="currentMask"
              @input="checkDocumentType"
              @keyup="validateDocument(data.document)"
              required
              :readonly="data.id"
            />
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group" :class="{ 'has-danger': !data.name }">
          <label for="name"
            >Razão Social <span class="m--font-danger">*</span></label
          >
          <div class="input-group">
            <input
              type="text"
              class="form-control m-input"
              name="name"
              id="name"
              placeholder=""
              v-model="data.name"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group" :class="{ 'has-danger': !data.co_name }">
          <label for="co_name"
            >Nome social <span class="m--font-danger">*</span></label
          >
          <div class="input-group">
            <input
              type="text"
              class="form-control m-input"
              name="co_name"
              id="co_name"
              placeholder=""
              v-model="data.co_name"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group" :class="{ 'has-danger': !data.email }">
          <label for="email"
            >E-mail <span class="m--font-danger">*</span></label
          >
          <div class="input-group">
            <input
              type="email"
              class="form-control m-input"
              name="email"
              id="email"
              placeholder=""
              v-model="data.email"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group" :class="{ 'has-danger': !data.size_id }">
          <label for="sizes"
            >Tamanho <span class="m--font-danger">*</span></label
          >
          <div class="input-group">
            <SelectCustomerSizes
              id="sizes"
              :first="'Selecione um tamanho'"
              :selected="data.size_id"
              @change="data.size_id = $event"
            />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group" :class="{ 'has-danger': !data.segment_id }">
          <label for="segments"
            >Segmento <span class="m--font-danger">*</span></label
          >
          <div class="input-group">
            <SelectCustomerSegments
              id="segments"
              :first="'Selecione um segmento'"
              :selected="data.segment_id"
              @change="data.segment_id = $event"
            />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div
          class="form-group"
          :class="{ 'has-danger': !data.business_executive_id }"
        >
          <label for="bussinesExecutive"> Executivo de negócios </label>
          <div class="input-group">
            <SelectBusinessExecutive
              id="bussinesExecutive"
              :selected="data.business_executive_id"
              @change="data.business_executive_id = $event"
            ></SelectBusinessExecutive>
          </div>
        </div>
      </div>
    </div>

    <hr class="row mt-5 mb-3" />
    <div class="row">
      <div class="col-md-12 text-right">
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.document.focus()"
            target="_self"
            class="m--font-danger"
            v-if="data.document && !validateDocument(data.document)"
            ><strong>Documento</strong> inválido *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.name.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.name"
            >O campo <strong>Razão social</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.co_name.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.co_name"
            >O campo <strong>Nome fantasia</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.email.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.email"
            >O campo <strong>e-mail</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.size_id.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.size_id"
            >O campo <strong>Tamanho</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.business_executive_id.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.business_executive_id"
            >O campo <strong>Executivo de negócios</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.segment_id.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.segment_id"
            >O campo <strong>Segmento</strong> é obrigatório *</a
          >
        </p>
      </div>
      <hr />
    </div>
    <div class="row mb-5">
      <div class="col-md-12 text-right">
        <button
          @click.prevent="saveForm()"
          class="btn"
          :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
          :disabled="!formIsValid"
        >
          <i class="fas fa-save" v-if="formIsValid"></i>
          <i class="fas fa-exclamation-triangle" v-else></i>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';
import { validationMixin } from '@/mixins/validationMixin.js';
import SelectCustomerSizes from '@/components/forms/SelectCustomerSizes';
import SelectBusinessExecutive from '@/components/forms/SelectBusinessExecutive';
import SelectCustomerSegments from '@/components/forms/SelectCustomerSegments';

export default {
  mixins: [returnMessageFormMixin, validationMixin],
  name: 'ProposalsSaveForm',
  components: {
    SelectCustomerSizes,
    SelectBusinessExecutive,
    SelectCustomerSegments,
  },
  props: {
    proposal: {
      type: Object,
    },
  },
  data() {
    return {
      data: {
        description: '',
        document: '',
        name: '',
        co_name: '',
        business_executive_id: '',
        size_id: '',
        segment_id: '',
        email: '',
        status: '',
        proposal_date: '',
      },
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      cpfMask: '###.###.###-##',
      cnpjMask: 'NN.NNN.NNN/NNNN-##',
      currentMask: 'NN.NNN.NNN/NNNN-##',
    };
  },
  methods: {
    checkDocumentType() {
      const cleanDocument = this.data.document.replace(/[^0-9A-Za-z]/g, '');
      if (cleanDocument.length > 11) {
        this.currentMask = this.cnpjMask;
      } else {
        this.currentMask = this.cpfMask;
      }
    },
    selectedCustomer(customersId) {
      this.data.customersIds = customersId.join(',');
    },
    async saveForm() {
      if (this.proposalId === 'add') {
        this.data.status_id = 2;
        this.data.product_id = 1;
        this.data.proposal_date = new Date();

        if (!this.searchDocument(this.data.document)) {
          return false;
        }
      }
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;
      if (alertEl) {
        alertEl.scrollIntoView();
      }

      const { data } = this;
      const url = `${baseApiUrl}/v1/proposal/save`;
      axios
        .post(url, data)
        .then((res) => {
          this.logMessageForm(res);
          this.$emit('savedProposal', res.data.item);
        })
        .catch((error) => this.logMessageFormFailed(error.response));
    },

    searchDocument(document) {
      if (!this.validateDocument(document)) {
        const cleanDocument = this.data.document.replace(/[^0-9A-Za-z]/g, '');
        const isCnpj = cleanDocument.length > 11;
        if (isCnpj && this.isAlphanumericCnpj(document)) {
          return false;
        }
        this.logMessageFormFailed({
          data: {
            message: 'Documento Inválido',
          },
        });
        return false;
      }
      return true;
    },
    validateDocument(document) {
      const cleanDocument = this.data.document.replace(/[^0-9A-Za-z]/g, '');
      if (cleanDocument.length > 11) {
        if (this.isAlphanumericCnpj(document)) {
          return true;
        }
        return this.validateCnpj(document);
      } else {
        return this.validateCpf(document);
      }
    },
  },
  computed: {
    proposalId() {
      return this.$store.state.showProposalSave;
    },
    action() {
      return this.$store.state.showProposalSave;
    },

    formIsValid() {
      return (
        this.validateDocument(this.data.document) &&
        this.data.document &&
        this.data.name &&
        this.data.co_name &&
        this.data.business_executive_id &&
        this.data.size_id &&
        this.data.segment_id &&
        this.data.email
      );
    },
  },
  beforeMount() {
    if (this.proposalId === 'add') {
      this.data.document = '';
      this.data.name = '';
      this.data.co_name = '';
      this.data.business_executive_id = '';
      this.data.size_id = '';
      this.data.segment_id = '';
      this.data.emai = '';
      this.data.status = 2;
      this.data.product_id = 1;
    }
  },
  watch: {
    proposal(newProposal) {
      this.data = newProposal;
    },
  },
};
</script>

<style>
.list-group {
  width: 50%;
  float: left;
}
.list-group b {
  display: block;
}
.card {
  border: none;
}

.m-quick-sidebar-overlay {
  background: rgba(0, 0, 0, 0.3);
}

@media (min-width: 1201px) {
  #m_quick_sidebar {
    width: 50% !important;
  }
}

@media (min-width: 601px) and (max-width: 1200px) {
  #m_quick_sidebar {
    width: 60% !important;
  }
}

@media (max-width: 600px) {
  #m_quick_sidebar {
    width: 100% !important;
  }
}
</style>
